<div class="container mb-5">
  <h1 class="text-grad-blue title_1">Composants présents ou stylisés pour LF</h1>
  <div class="bg-grey br-16 pb-5 px-3 py-4 mt-4 w-fit-content">
    <h2 class="title_2">Sommaire</h2>
    <ul>
      <li class="pointer" (click)="scroll(buttons)">Boutons</li>
      <li class="pointer" (click)="scroll(fonts)">Font</li>
      <li class="pointer" (click)="scroll(colors)">Couleurs</li>
      <li class="pointer" (click)="scroll(customInputs)">Inputs custom
        <ul>
          <li>Input radio</li>
          <li>Input date</li>
          <li>Input recherche & autocomplete</li>
          <li>Input téléphone</li>
          <li>Input pays</li>
        </ul>
      </li>
      <li><span class="pointer" (click)="scroll(matComponents)">Mat components</span>
        <ul>
          <li class="pointer" (click)="scroll(inputs)">Inputs</li>
          <li class="pointer" (click)="scroll(checkboxes)">Checkboxes</li>
          <li class="pointer" (click)="scroll(chips)">Chips</li>
          <li class="pointer" (click)="scroll(accordion)">Accordion</li>
          <li class="pointer" (click)="scroll(paginator)">Paginator</li>
          <li class="pointer" (click)="scroll(tabs)">Tabs</li>
          <li class="pointer" (click)="scroll(tooltip)">tooltip</li>
          <li class="pointer" (click)="scroll(menu)">Menu</li>
        </ul>
      </li>
      <li class="pointer" (click)="scroll(slider)">Slider</li>
      <li class="pointer" (click)="scroll(carousel)">Carousel</li>
      <li class="pointer" (click)="scroll(help)">Composant help</li>
      <li class="pointer" (click)="scroll(icons)">Icones customs</li>
    </ul>
  </div>


  <div class="mt-5">
    <ng-container>
      <h2 class="title_2" #buttons>
        Les boutons
        <a target="_blank" class="minitext_2" href="https://getbootstrap.com/docs/5.3/components/buttons/">(Liste des
          boutons bootstrap)</a>
      </h2>
      <div style="height:30rem" class="mt-4 column">
        <div class="d-flex gap-2">
          <button class="btn btn-primary">Bouton primary</button>
          <button class="btn btn-primary" disabled>Bouton primary disabled</button>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-link">Bouton link</button>
          <button class="btn btn-link" disabled>Bouton link disabled</button>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-danger">Bouton link</button>
          <button class="btn btn-danger" disabled>Bouton link disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-success">Bouton success</button>
          <button class="btn btn-success" disabled>Bouton success disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-outline-primary">Bouton outline primary</button>
          <button class="btn btn-outline-primary" disabled>Bouton outline primary disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-border-primary">Bouton border primary</button>
          <button class="btn btn-border-primary" disabled>Bouton border primary disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-black-border">Bouton black border</button>
          <button class="btn btn-black-border" disabled>Bouton black border disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-yellow">Bouton yellow</button>
          <button class="btn btn-yellow" disabled>Bouton yellow disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-interaction">Bouton interaction</button>
          <button class="btn btn-interaction" disabled>Bouton interaction disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-grey">Bouton grey</button>
          <button class="btn btn-grey" disabled>Bouton grey disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-primary-opacified">Bouton primary opacifié</button>
          <button class="btn btn-primary-opacified" disabled>Bouton primary opacifié disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-gradient-blue">Bouton grad</button>
          <button class="btn btn-gradient-blue" disabled>Bouton grad disabled</button>
        </div>
        <div class="btn-gradiant-red d-flex gap-2">
          <button class="btn">Bouton grad</button>
          <button class="btn" disabled>Bouton grad disabled</button>
        </div>

        <div class="btn-gradiant-red text_only d-flex gap-2">
          <button class="btn">Bouton grad 2</button>
          <button class="btn" disabled>Bouton grad 2 disabled</button>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-secondary">Bouton secondary</button>
          <button class="btn btn-secondary" disabled>Bouton secondary disabled</button>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-ternary">Bouton ternary <small>(jamais utilisé)</small></button>
          <button class="btn btn-ternary" disabled>Bouton ternary disabled <small>(jamais utilisé)</small></button>
        </div>
        <div class="d-flex gap-2"></div>


      </div>
    </ng-container>

    <hr>

    <ng-container>
      <h2 class="title_2" #fonts>
        Les fonts
        <a target="_blank" class="minitext_2" href="https://getbootstrap.com/docs/5.3/content/typography/">(Liste des
          fonts bootstrap)</a>
      </h2>
      <div class="column mt-4" style="height:20rem">
        <h1>Titre en h1</h1>
        <h2>Titre en h2</h2>
        <h3>Titre en h3</h3>
        <h4>Titre en h4</h4>
        <h5>Titre en h5</h5>
        <h6>Titre en h6</h6>
        <p>Un paragraphe plus ou moins long blablabla lalala</p>
        <span>Un span classique, la div c'est la même</span><br>
        <small>Une balise small classique</small>
        <div class="title_1">Un title 1 custom de chez nous</div>
        <div class="title_2">Un title 2 custom de chez nous</div>
        <div class="title_3">Un title 3 custom de chez nous</div>
        <div class="title_4">Un title 4 custom de chez nous</div>
        <div class="subtitle_1">Un subtitle 1 custom de chez nous</div>
        <div class="subtitle_2">Un subtitle 2 custom de chez nous</div>
        <div class="subtitle_3">Un subtitle 3 custom de chez nous</div>
        <div class="minitext_1">Un minitext 1 custom de chez nous</div>
        <div class="minitext_2">Un minitext 2 custom de chez nous</div>
        <div class="minitext_3">Un minitext 3 custom de chez nous</div>
      </div>
    </ng-container>
    <hr>

    <ng-container>
      <h2 class="title_2" #colors>
        Les couleurs LF
        <a target="_blank" class="minitext_2" href="https://getbootstrap.com/docs/5.3/customize/color/">(Liste des
          couleurs bootstrap)</a>
      </h2>
      <div class="column mt-4" style="height: 10rem">
        <p class="text-primary">Text primary</p>
        <p class="text-danger">Text danger</p>
        <p class="text-success">Text success</p>
        <p class="text-grad-blue">Gradiant bleu</p>
        <p class="text-grey-light">Text grey light</p>
        <p class="text-grad-red">Text grad red</p>
        <p class="txt-blue-sky">Text blue sky</p>
        <p class="txt-dark-blue">Text dark blue</p>
        <p class="txt-darkGray">Text dark gray</p>
        <p class="txt-peach">Text peach</p>
        <p class="txt-yellow-happy">Text yellow happy</p>
      </div>
    </ng-container>

    <hr>

    <ng-container>
      <h2 class="title_2 mt-2" #customInputs>
        Inputs customs
      </h2>

      <h3 class="title_3">Input radio</h3>
      <form [formGroup]="form" class="d-flex justify-content-start mt-2 gap-16">
        <label class="d-flex gap-8 pointer">
          {{ "COMMON.USER.GENDER_MALE" | translate }}
          <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="male">
        </label>

        <label class="d-flex gap-8 pointer">
          {{ "COMMON.USER.GENDER_FEMALE" | translate }}
          <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="female">
        </label>
      </form>

      <h3 class="title_3 mt-4">Input date</h3>
      <app-birthdate-divided></app-birthdate-divided>

      <h3 class="title_3 mt-4">Input recherche & autocomplete</h3>
      <app-accommodation-city-input></app-accommodation-city-input>

      <form [formGroup]="form">
        <h3 class="title_3 mt-4">Input téléphone</h3>
        <ngx-intl-tel-input [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [formControl]="form.controls.phone"
                            [maxLength]="20"
                            [ngClass]="{ 'is-invalid': form.controls.phone.errors }"
                            [phoneValidation]="true"
                            [selectFirstCountry]="false"
                            [separateDialCode]="true"
                            class="ngx-intl-tel_mat-form-style subtitle_2"
                            formControl="phone"
                            formControlName="phone">
        </ngx-intl-tel-input>

        <h3 class="title_3 my-4">Input pays</h3>
        <mat-select-country class="pb-2 nationality" appearance="legacy" label="{{ 'PROFILE.NATIONALITY' | translate }}"
                            placeHolder="{{ 'PROFILE.NATIONALITY' | translate }}"
                            required
                            [formControl]="form.controls.nationality"
                            [ngClass]="{ 'is-invalid': form.controls.nationality.errors }">
        </mat-select-country>
      </form>






    </ng-container>

    <hr>

    <ng-container>
      <h2 class="title_2" #matComponents>
        Les composants mat-material
        <a target="_blank" class="minitext_2" href="https://material.angular.io/">(Liste des composants)</a>
      </h2>

      <h3 class="title_3 mt-4" #inputs>
        Inputs
        <a class="minitext_2" href="https://material.angular.io/components/form-field/overview">(overview)</a>
      </h3>
      <form [formGroup]="form" class="d-flex flex-column gap-4 justify-content-start">
        <mat-form-field appearance="fill">
          <mat-label>Input</mat-label>
          <input formControlName="first" matInput required>
          <mat-error>Champs requis</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Select</mat-label>
          <mat-select formControlName="second" required>
            <mat-option value="one">First option</mat-option>
            <mat-option value="two">Second option</mat-option>
          </mat-select>
          <mat-error>Champs requis</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Select multiple</mat-label>
          <mat-select formControlName="third" multiple required>
            <mat-option value="one">First option</mat-option>
            <mat-option value="two">Second option</mat-option>
          </mat-select>
          <mat-error>Champs requis</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Textarea</mat-label>
          <textarea formControlName="forth" matInput required></textarea>
          <mat-error>Champs requis</mat-error>
        </mat-form-field>
      </form>

      <h3 class="title_3 mt-4" #checkboxes>
        Checkboxes
        <a class="minitext_2" href="https://material.angular.io/components/checkbox/overview">(overview)</a>
      </h3>
      <mat-checkbox>Check me!</mat-checkbox>
      <mat-checkbox [disabled]="true">Disabled</mat-checkbox>

      <h3 class="title_3 mt-4" #chips>
        Chips
        <a class="minitext_2" href="https://material.angular.io/components/chips/overview">(overview)</a>
      </h3>
      <mat-chip-set aria-label="Fish selection">
        <mat-chip>One fish</mat-chip>
        <mat-chip>Two fish</mat-chip>
        <mat-chip>Three fish</mat-chip>
        <mat-chip disabled>Four fish</mat-chip>
      </mat-chip-set>

      <h3 class="title_3 mt-4" #accordion>
        Accordion
        <a class="minitext_2" href="https://material.angular.io/components/expansion/overview">(overview)</a>
      </h3>

      <h4 class="subtitle_1">Style 1</h4>
      <mat-accordion class="info-accordion">
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title> This is the expansion title</mat-panel-title>
            <mat-panel-description> This is a summary of the content</mat-panel-description>
          </mat-expansion-panel-header>
          <p>This is the primary content of the panel.</p>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Self aware panel</mat-panel-title>
            <mat-panel-description>
              description
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>I'm visible because I am open</p>
        </mat-expansion-panel>
      </mat-accordion>

      <h4 class="subtitle_1 mt-2">Style 2</h4>
      <mat-accordion class="custom-panel">
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title> This is the expansion title</mat-panel-title>
            <mat-panel-description> This is a summary of the content</mat-panel-description>
          </mat-expansion-panel-header>
          <p>This is the primary content of the panel.</p>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Self aware panel</mat-panel-title>
            <mat-panel-description>
              description
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>I'm visible because I am open</p>
        </mat-expansion-panel>
      </mat-accordion>

      <h3 class="title_3 mt-4" #paginator>
        Paginator
        <a class="minitext_2" href="https://material.angular.io/components/paginator/overview">(overview)</a>
      </h3>
      <mat-paginator [length]="100"
                     [pageSize]="10"
                     [pageSizeOptions]="[5, 10, 25, 100]"
                     aria-label="Select page">
      </mat-paginator>


      <h3 class="title_3 mt-4" #tabs>
        Tabs
        <a class="minitext_2" href="https://material.angular.io/components/tabs/overview">(overview)</a>
      </h3>
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
        @for (link of links; track link) {
          <a mat-tab-link
             (click)="activeLink = link"
             [active]="activeLink == link"> {{ link }} </a>
        }
        <a mat-tab-link disabled>Disabled Link</a>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

      <h3 class="title_3 mt-4" #tooltip>
        Tooltip
        <a class="minitext_2" href="https://material.angular.io/components/tooltip/overview">(overview)</a>
      </h3>

      <small class="text-underline subtitle_2 mediumGray"
             ngbTooltip="Texte en tooltip yipee"
             placement="top-start">Hover pour voir la tooltip</small>

      <h3 class="title_3 mt-4" #menu>
        Menu
        <a class="minitext_2" href="https://material.angular.io/components/menu/overview">(overview)</a>
      </h3>

      <button mat-icon-button [matMenuTriggerFor]="menuBtn" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menuBtn="matMenu">
        <button mat-menu-item>
          <mat-icon>dialpad</mat-icon>
          <span>Redial</span>
        </button>
        <button mat-menu-item disabled>
          <mat-icon>voicemail</mat-icon>
          <span>Check voice mail</span>
        </button>
        <button mat-menu-item>
          <mat-icon>notifications_off</mat-icon>
          <span>Disable alerts</span>
        </button>
      </mat-menu>

    </ng-container>

    <hr>

    <ng-container>
      <h3 class="title_3 mt-4" #slider>
        Slider
      </h3>
      <ngx-slider
        class="m-0 isInside"
        value="300"
        highValue="500"
        [options]="priceSliderOptions"></ngx-slider>
    </ng-container>
    <hr>

    <ng-container>
      <h2 class="title_2 mt-2" #carousel>
        Carousel
      </h2>

      <app-accommodation-photo [propertyPhotos]="propertyPhotos"
                               [selectedCity]="selectedCity"
                               [room]="room"></app-accommodation-photo>

    </ng-container>

    <hr>

    <ng-container>
      <h2 class="title_2 mt-2" #help>
        Bouton need help
      </h2>
      <app-need-help></app-need-help>
    </ng-container>

    <hr>

    <ng-container>
      <h2 class="title_2 mt-2 d-flex justify-content-between" #icons>
        Icones customs
        <button class="btn btn-secondary btn-sm" (click)="addBackground()">Ajout background</button>
      </h2>
      <div class="d-flex flex-wrap gap-3 mt-2">
        @for (icon of IconArray;track $index) {
          <div class="d-flex gap-2 p-2 align-items-center br-2" [style.background-color]="iconBg">
            <lf-icon [name]="icon" width="18px" height="18px"></lf-icon>
            <small>{{icon}}</small>
          </div>
        }
      </div>




    </ng-container>

  </div>
</div>
